import { MapPin, Phone, Navigation, CalendarCheck, Package, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { ExternalCta } from "@/components/common/ExternalCta";

// Compact location summary card (top section of Locations page)
export const LocationBlock = ({ item }) => {
  return (
    <div
      data-testid="location-block"
      className="group flex flex-col overflow-hidden rounded-xl border border-border bg-card transition-colors duration-200 hover:border-[hsl(var(--brand-red))]"
    >
      {item.image_url && (
        <div className="relative h-52 overflow-hidden">
          <img
            src={item.image_url}
            alt={item.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
          <h3 className="absolute bottom-4 left-5 display-title text-3xl text-white">{item.name}</h3>
        </div>
      )}

      <div className="flex flex-1 flex-col p-6">
        <div className="space-y-2 text-sm">
          <p className="flex items-start gap-2 text-muted-foreground">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
            <span data-testid="location-address">{item.address}<br />{item.city}</span>
          </p>
          {item.phone && (
            <a
              href={`tel:${item.phone.replace(/[^0-9+]/g, "")}`}
              data-testid="location-phone"
              className="flex items-center gap-2 text-muted-foreground transition-colors hover:text-foreground"
            >
              <Phone className="h-4 w-4 text-brand" />{item.phone}
            </a>
          )}
        </div>

        {/* 4 action buttons */}
        <div className="mt-6 grid grid-cols-2 gap-2.5">
          <ExternalCta
            href={item.map_url}
            variant="secondary"
            showIcon={false}
            testid="location-directions-btn"
            className="px-3 py-2.5 text-xs"
          >
            <Navigation className="h-4 w-4 text-brand" /> Get Directions
          </ExternalCta>
          <ExternalCta
            href={item.booking_url}
            variant="primary"
            showIcon={false}
            testid="location-book-btn"
            className="px-3 py-2.5 text-xs"
          >
            <CalendarCheck className="h-4 w-4" /> Book
          </ExternalCta>
          <ExternalCta
            href={item.packages_url}
            variant="secondary"
            showIcon={false}
            testid="location-packages-btn"
            className="px-3 py-2.5 text-xs"
          >
            <Package className="h-4 w-4 text-brand" /> View Packages
          </ExternalCta>
          <Link
            to="/contact"
            data-testid="location-contact-btn"
            className="inline-flex items-center justify-center gap-2 rounded-md border border-border bg-transparent px-3 py-2.5 text-xs font-semibold uppercase tracking-wide text-foreground transition-colors duration-200 hover:bg-accent active:scale-[0.98]"
          >
            <Mail className="h-4 w-4 text-brand" /> Contact
          </Link>
        </div>
      </div>
    </div>
  );
};
